import React from 'react';
import { INGREDIENT_SHOP, BUFF_SHOP } from '../../../data/regionalChef/shopData';

const PrepShop = ({ gameLogic }) => {
  const { 
    money, dailyTarget, masterDeck, activeBuffs, maxBuffSlots, currentModifier, // 👈 ดึง currentModifier มา
    buyIngredient, buyBuff, startNextDay, initGame
  } = gameLogic;

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', fontFamily: 'sans-serif', padding: '20px', paddingBottom: '50px' }}>
      
      <div style={{ backgroundColor: '#3742fa', color: 'white', padding: '20px', borderRadius: '12px', textAlign: 'center', marginBottom: '20px', boxShadow: '0 4px 15px rgba(55, 66, 250, 0.3)' }}>
        <h2 style={{ margin: '0 0 10px 0' }}>🛒 เตรียมตัวก่อนเปิดร้าน (Day 0)</h2>
        <p style={{ margin: 0 }}>คุณได้รับเงินทุนเริ่มต้น จัดเด็ควัตถุดิบได้ตามใจชอบ (ซื้อซ้ำได้ไม่จำกัด)</p>
        
        <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', marginTop: '20px' }}>
            <div style={{ textAlign: 'center' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#dcdde1' }}>ทุนตั้งต้น</p>
                <p style={{ margin: 0, fontSize: '28px', color: '#feca57' }}><strong>฿{money}</strong></p>
            </div>
            
            <div style={{ borderLeft: '2px solid rgba(255,255,255,0.2)', paddingLeft: '30px', textAlign: 'center' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#dcdde1' }}>🎯 เป้าหมาย (Day 1)</p>
                <p style={{ margin: 0, fontSize: '28px', color: '#7bed9f' }}><strong>฿{dailyTarget}</strong></p>
            </div>
        </div>
      </div>

      {/* ⚠️ โชว์เงื่อนไขด่านถัดไปให้เตรียมตัว */}
      <div style={{ backgroundColor: currentModifier.color, color: 'white', padding: '15px', borderRadius: '8px', marginBottom: '20px', textAlign: 'center', fontWeight: 'bold' }}>
        ⚠️ เงื่อนไขด่านถัดไป: {currentModifier.name} - {currentModifier.desc}
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
         <h3 style={{ margin: 0 }}>🥩 เลือกซื้อวัตถุดิบ (มีแล้ว {masterDeck.length} ใบ)</h3>
         <button onClick={initGame} style={{ padding: '8px 15px', backgroundColor: '#ff4757', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>🔄 รีเซ็ตการซื้อ</button>
      </div>
      <p style={{ fontSize: '14px', color: '#ff4757', marginTop: 0 }}>*ต้องมีไพ่อย่างน้อย 4 ใบ เพื่อเริ่มเกม</p>
      
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '40px' }}>
        {INGREDIENT_SHOP.map(item => {
          const countInDeck = masterDeck.filter(id => id === item.id).length;
          return (
            <div key={item.id} style={{ border: '2px solid #dfe4ea', padding: '15px 10px', borderRadius: '8px', textAlign: 'center', width: '120px', position: 'relative', backgroundColor: 'white' }}>
              {countInDeck > 0 && (
                <div style={{ position: 'absolute', top: '-10px', right: '-10px', backgroundColor: '#ff4757', color: 'white', borderRadius: '50%', width: '28px', height: '28px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: '14px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
                  {countInDeck}
                </div>
              )}
              <h4 style={{ margin: '0 0 10px 0', color: '#2f3542' }}>{item.name}</h4>
              <p style={{ margin: '0 0 10px 0', color: '#ff4757', fontWeight: 'bold' }}>฿{item.price}</p>
              <button 
                onClick={() => buyIngredient(item.id, item.price)}
                disabled={money < item.price}
                style={{ width: '100%', padding: '8px', backgroundColor: money >= item.price ? '#ffa502' : '#ced6e0', color: 'white', border: 'none', borderRadius: '4px', cursor: money >= item.price ? 'pointer' : 'not-allowed', fontWeight: 'bold' }}
              >
                หยิบใส่กอง
              </button>
            </div>
          );
        })}
      </div>

      <h3 style={{ margin: '0 0 15px 0' }}>🛠️ ซื้ออุปกรณ์ก้นครัว ({activeBuffs.length}/{maxBuffSlots})</h3>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '40px' }}>
        {BUFF_SHOP.map(item => {
          const hasBuff = activeBuffs.includes(item.id);
          const isFull = activeBuffs.length >= maxBuffSlots && !hasBuff;
          return (
            <div key={item.id} style={{ border: '2px solid #dfe4ea', padding: '15px', borderRadius: '8px', width: '200px', backgroundColor: 'white' }}>
              <h4 style={{ margin: '0 0 5px 0', color: '#2f3542' }}>{item.name}</h4>
              <p style={{ fontSize: '12px', margin: '0 0 10px 0', minHeight: '34px', color: '#57606f', lineHeight: '1.5' }}>{item.desc}</p>
              <p style={{ margin: '0 0 10px 0', color: '#ff4757', fontWeight: 'bold' }}>฿{item.price}</p>
              <button 
                onClick={() => buyBuff(item.id, item.price)}
                disabled={money < item.price || hasBuff || isFull}
                style={{ width: '100%', padding: '8px', backgroundColor: hasBuff ? '#2ed573' : (money >= item.price && !isFull ? '#3742fa' : '#ced6e0'), color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
              >
                {hasBuff ? 'มีแล้ว' : (isFull ? 'ช่องเต็ม' : 'ซื้ออุปกรณ์')}
              </button>
            </div>
          );
        })}
      </div>

      <div style={{ position: 'sticky', bottom: '20px', zIndex: 10 }}>
        <button 
          onClick={() => startNextDay(true)}
          disabled={masterDeck.length < 4}
          style={{ width: '100%', padding: '15px', fontSize: '18px', backgroundColor: masterDeck.length >= 4 ? '#2ed573' : '#a4b0be', color: 'white', border: 'none', borderRadius: '8px', cursor: masterDeck.length >= 4 ? 'pointer' : 'not-allowed', fontWeight: 'bold', boxShadow: '0 4px 15px rgba(0,0,0,0.2)' }}
        >
          {masterDeck.length >= 4 ? 'พร้อมแล้ว! เริ่มเปิดร้านวันที่ 1 🚀' : 'ต้องมีไพ่อย่างน้อย 4 ชิ้นก่อน'}
        </button>
      </div>
    </div>
  );
};

export default PrepShop;